if ($(".id--17").length) {
  $('label[for="remark"]').text(vasePoznamka)


  if (getShoptetDataLayer("customer").registered) {
  } else {
    $('p.label').closest('.form-group').hide();
    $('p.label').closest(".box.co-contact-information").prepend(`
            <div class="customLogin">
                    <p>Máte u nás účet? Přihlaste se, údaje se vyplní automaticky. 
                <span class="customLoginPopup">Přihlásit se</span></p>
        
            </div>
        `);

    $("html").on("click", ".customLoginPopup", function () {
      $("body").addClass("user-action-visible login-window-visible");
    });

    //$(".co-box.reg").prepend($("#add-note").closest(".form-group"));

  }
  $("#note").addClass("visible");
  $(".co-box-additional .form-group input#add-note").prop("checked", true);

  const selectedDate = localStorage.getItem("klasekSelectedDate") || "";
  const selectedTime = JSON.parse(localStorage.getItem("klasekSelectedPickup"))?.time || "";

  function formatDate(dateString) {
    if (!dateString) return "";

    const parts = dateString.split("-");

    if (parts.length !== 3) return "";

    const [year, month, day] = parts;

    if (!year || !month || !day) return "";

    return `${Number(day)}.${Number(month)}.${year}`;
  }

  $(".co-contact-information").append(`
    <div class="form-group smart-label-wrapper form-group--inline">
        <label for="order_additional_field_01_name">Datum vyzvednutí</label>
        <div class="form-control-wrapper js-validated-element-wrapper">
          <input
              name="varchar1"
              type="text"
              id="order_additional_field_01_name"
              class="form-control"
              value="${formatDate(selectedDate)}"
              readonly
          >
        </div>
    </div>

    <div class="form-group smart-label-wrapper form-group--inline">
        <label for="order_additional_field_02_name">Čas vyzvednutí</label>
        <div class="form-control-wrapper js-validated-element-wrapper">
          <input
              name="varchar2"
              type="text"
              id="order_additional_field_02_name"
              class="form-control"
              value="${selectedTime}"
              readonly
          >
        </div>
    </div>
`);

  $("html").on("click", "#submit-order.next-step-finish", function () {
    var mhall = {
      email: $("input#email").val(),
      phone: $("input#phone").val(),
      name: $("input#billFullName").val().split(" ")[0],
      surname: $("input#billFullName").val().split(" ")[1] || "",
      street: $("input#billStreet").val(),
      city: $("input#billCity").val(),
      zip: $("input#billZip").val(),
      country: $("select#billCountryId option:selected").text().trim(),
    };

    var mhArr = JSON.parse(sessionStorage.getItem("get_info")) || [];

    mhArr = mhArr.filter((item) => item.email !== mhall.email);

    mhArr.unshift(mhall);

    sessionStorage.setItem("get_info", JSON.stringify(mhArr));
  });
}

if ($(".id--16, .id--17").length) {
  $(".cart-inner").prepend($(".cart-header"));
  $("#checkoutContent").append($(".next-step .next-step-back").clone());
  $("#checkoutSidebar").append($(".next-step .next-step-back").clone());
}
if ($(".id--16").length) {
}
if ($(".id--9").length) {
  function syncDiscountCouponState($checkbox) {
    var $targetCheckbox = $checkbox && $checkbox.length ? $checkbox : $("#discount-checkbox").first();

    if (!$targetCheckbox.length) {
      return;
    }

    $targetCheckbox.closest(".extras-col").find(".discount-coupon").toggleClass("active", $targetCheckbox.prop("checked"));
  }

  $(document)
    .off("change.discountCoupon", "#discount-checkbox")
    .on("change.discountCoupon", "#discount-checkbox", function () {
      syncDiscountCouponState($(this));
    });

  function mhProductInfoMove() {
    $(".cart-table tr").each(function () {
      const $img = $(this).find(".cart-p-image img");
      const src = $img.attr("data-src") || $img.attr("src");
      if (src) {
        const newSrc = src.replace("/related/", "/detail/");
        $img.attr("data-src", newSrc);
        $img.attr("src", newSrc);
      }
      var findcenazakus = $(this).find(".p-price.p-cell").html();
      var findptotal = $(this).find(".p-total");
      $(this)
        .find(".p-name")
        .append('<div class="avail">' + $(this).find(".p-availability").html() + "</div>");
      $(findptotal).prepend('<span class="cenazaks">' + findcenazakus + "</span>");
    });
    if ($(".cart-table .p-discount").length) {
      $(".cart-table ").prepend(`
                <thead class="table-header">
                <tr>
                    <th class="prod" colspan="2">Produkt</th>
                    <th class="avail">Dostupné množství</th>
                    <th class="qty">Počet</th>
                    <th class="unit">Cena za kus</th>
                    <th class="sale">Sleva</th>
                    <th class="total">Celkem</th>
                </tr>
                    </thead>
            `);
    } else {
      $(".cart-table ").prepend(`
                <thead class="table-header">
                <tr>
                    <th class="prod" colspan="2">Produkt</th>
                    <th class="avail">Dostupné množství</th>
                    <th class="qty">Počet</th>
                    <th class="unit">Cena za kus</th>
                    <th class="total">Celkem</th>
                </tr>
                    </thead>
            `);
    }

    $(".sidebar-in-cart").prepend($(".cart-summary"));
    $(".cart-summary").append($(".summary-wrapper .next-step-back").clone());
    $(".summary-wrapper").after($(".summary-wrapper .next-step-back").clone());

    const $extrasCol = $(".cart-summary .extras-wrapper .extras-col:first");

    if ($extrasCol.length && !$("#discount-checkbox").length) {
      $extrasCol.append(`
      <input type="checkbox" id="discount-checkbox">
        <label for="discount-checkbox">
          Slevový kupón
        </label>
      `);
    }

    syncDiscountCouponState();
  }
  mhProductInfoMove();

  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    mhProductInfoMove();
  });
}

$(document).ready(function () {
  emptyCart();
});
document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  emptyCart();
});
function emptyCart() {
  if ($(".cart-empty").length) {
    $("body").addClass("cartEmpty");
    $(".cart-heading").before('<div class="imgBox"></div>');
    $('<div class="text-center"><a href="/" class="btn btn-conversion">Zpět</a></div>').appendTo(".cart-empty");
  }
}
